import axios from 'axios';

export const apiCall = ({ url, method }) => (data) =>
  axios({ url, method, data })
    .then((result) => [null, result])
    .catch((error) => [error, null]);
